import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='componentError: Flow<PrimerError>' mdxType="Item">
      <p>{`Get a `}<a parentName="p" {...{
          "href": "https://kotlinlang.org/api/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-flow/"
        }}>{`Flow`}</a>{`
of `}<a parentName="p" {...{
          "href": "./../../../common/primerError"
        }}>{`PrimerError`}</a>{` objects that represent errors emitted by this component.
Subscribers can observe and handle errors using this Flow.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      